import React from "react";
import "./TermsOfUsage.scss";

const TermsOfUsage = () => {
  return (
    <div className="terms-of-usage">
      <div className="terms-of-usage__container">
        <h1>Terms of Usage</h1>
        <div className="terms-of-usage__content">
          <section className="intro">
            <h2>Agreement to Terms</h2>
            <p>
              By downloading, installing, or using ShadowDial ("the App"), you
              agree to be bound by these Terms of Usage. These terms constitute
              a legally binding agreement between you and the developer of
              ShadowDial.
            </p>
            <p>
              <strong>Important:</strong> If you do not agree to these terms,
              please do not download, install, or use the App.
            </p>
          </section>

          <section>
            <h2>Permitted Use</h2>
            <p>ShadowDial is designed for legitimate purposes including:</p>
            <ul>
              <li>
                <strong>Social Situations:</strong> Providing a polite exit from
                uncomfortable social situations
              </li>
              <li>
                <strong>Practice:</strong> Rehearsing phone conversations or
                public speaking scenarios
              </li>
              <li>
                <strong>Entertainment:</strong> Light-hearted pranks among
                friends (with consent)
              </li>
              <li>
                <strong>Personal Safety:</strong> Creating an escape mechanism
                in potentially unsafe situations
              </li>
              <li>
                <strong>Professional Training:</strong> Role-playing and
                communication skill development
              </li>
            </ul>
          </section>

          <section>
            <h2>Prohibited Activities</h2>
            <p>You agree NOT to use ShadowDial for:</p>
            <ul>
              <li>
                <strong>Illegal Activities:</strong> Any purpose that violates
                local, state, or federal laws
              </li>
              <li>
                <strong>Fraud or Deception:</strong> Deceiving emergency
                services, employers, or authorities
              </li>
              <li>
                <strong>Harassment:</strong> Disrupting others' peace or
                creating disturbances
              </li>
              <li>
                <strong>Emergency Situations:</strong> Interfering with genuine
                emergency communications
              </li>
              <li>
                <strong>Commercial Fraud:</strong> Avoiding legitimate business
                obligations or commitments
              </li>
              <li>
                <strong>Academic Dishonesty:</strong> Cheating on exams or
                avoiding academic responsibilities
              </li>
              <li>
                <strong>Workplace Violations:</strong> Violating employer
                policies or employment agreements
              </li>
            </ul>
          </section>

          <section>
            <h2>User Responsibilities</h2>
            <p>As a user of ShadowDial, you are responsible for:</p>
            <ul>
              <li>Using the app ethically and responsibly</li>
              <li>
                Ensuring your use complies with applicable laws and regulations
              </li>
              <li>Respecting others' rights and privacy</li>
              <li>Not using the app to cause harm or distress to others</li>
              <li>
                Understanding the social and legal implications of your actions
              </li>
            </ul>
          </section>

          <section>
            <h2>App Functionality and Limitations</h2>
            <p>
              ShadowDial provides fake call simulation functionality. Please
              understand:
            </p>
            <ul>
              <li>
                <strong>Simulation Only:</strong> All calls generated are fake
                and for entertainment purposes
              </li>
              <li>
                <strong>No Real Connections:</strong> The app does not make
                actual phone calls or connections
              </li>
              <li>
                <strong>Local Operation:</strong> All functionality operates
                locally on your device
              </li>
              <li>
                <strong>No Guarantees:</strong> We do not guarantee
                uninterrupted or error-free operation
              </li>
            </ul>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>
              ShadowDial and all its content, features, and functionality are
              owned by the developer and are protected by intellectual property
              laws. You may not:
            </p>
            <ul>
              <li>Copy, modify, or distribute the app's code or design</li>
              <li>Reverse engineer or attempt to extract source code</li>
              <li>Use the app's name, logo, or branding without permission</li>
              <li>Create derivative works based on the app</li>
            </ul>
          </section>

          <section>
            <h2>Disclaimers and Warranties</h2>
            <p>
              ShadowDial is provided "as is" without warranties of any kind. We
              disclaim all warranties including:
            </p>
            <ul>
              <li>Merchantability and fitness for a particular purpose</li>
              <li>Non-infringement of third-party rights</li>
              <li>Uninterrupted or error-free operation</li>
              <li>Accuracy, reliability, or completeness of information</li>
            </ul>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, the developer of
              ShadowDial shall not be liable for:
            </p>
            <ul>
              <li>Any indirect, incidental, or consequential damages</li>
              <li>Loss of data, profits, or business opportunities</li>
              <li>Damages resulting from misuse of the application</li>
              <li>
                Any damages exceeding the amount paid for the app (if
                applicable)
              </li>
            </ul>
          </section>

          <section>
            <h2>Age Restrictions</h2>
            <p>
              ShadowDial is intended for users aged 13 and above. Users under 18
              should obtain parental consent before using the app. Parents and
              guardians are responsible for monitoring their children's use of
              the application.
            </p>
          </section>

          <section>
            <h2>Termination</h2>
            <p>
              These terms remain in effect while you use ShadowDial. You may
              terminate this agreement by uninstalling the app. We reserve the
              right to terminate or restrict access to the app for violations of
              these terms.
            </p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>
              We may update these Terms of Usage from time to time. Changes will
              be posted within the app and on our website. Continued use of
              ShadowDial after changes constitutes acceptance of the updated
              terms.
            </p>
          </section>

          <section>
            <h2>Governing Law</h2>
            <p>
              These Terms of Usage are governed by applicable laws. Any disputes
              arising from these terms or use of the app will be resolved
              through appropriate legal channels in accordance with local
              jurisdiction.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsage;
